import { Module } from "@nestjs/common";
import { TypeOrmModule } from "@nestjs/typeorm";
import { PackingMaterialPricesEntity } from "./packing-material-prices-entity";
import { PackingMaterialPricesService } from "./packing-material-prices-service";
import { ApplicationExceptionHandler } from "libs/shared-utils/error-messages/src/lib/global-errors/application-exception-handler";
import { PackingMaterialPricesController } from "./packing-material-prices-controller";

@Module({
    imports:[
        TypeOrmModule.forFeature([PackingMaterialPricesEntity])
    ],
    providers:[PackingMaterialPricesService,ApplicationExceptionHandler],
    controllers:[PackingMaterialPricesController],
    exports:[PackingMaterialPricesService]
})
export class PackingMaterialPricesModule{}